var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.showIcon
    ? _c(
        "svg",
        {
          attrs: {
            "xmlns:svg": "http://www.w3.org/2000/svg",
            xmlns: "http://www.w3.org/2000/svg",
            version: "1.0",
            width: "24",
            height: "22",
            viewBox: "0 0 595.62 814.28",
            id: "svg2",
            "xml:space": "preserve",
          },
        },
        [
          _c(
            "g",
            {
              attrs: {
                transform:
                  "matrix(11.326781,0,0,11.326781,-4868.329,-923.21654)",
                id: "g2305",
              },
            },
            [
              _c("polygon", {
                staticStyle: {
                  fill: "#000000",
                  "fill-rule": "nonzero",
                  stroke: "none",
                  "stroke-width": "0.28",
                  "stroke-linecap": "butt",
                  "stroke-linejoin": "bevel",
                },
                attrs: {
                  points:
                    "512.82,57.78 518.76,57.78 521.64,67.86 524.7,57.78 529.74,57.78 524.34,72.36 518.4,72.36 512.82,57.78 ",
                  transform: "translate(-70.400506,64.800465)",
                  id: "polygon39",
                },
              }),
              _vm._v(" "),
              _c("polygon", {
                attrs: {
                  points:
                    "531.72,57.78 537.48,57.78 540.54,67.86 543.6,57.78 548.64,57.78 543.24,72.36 537.3,72.36 531.72,57.78 ",
                  transform: "translate(-70.400506,64.800465)",
                  id: "polygon41",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M 484.35949,132.30047 C 484.35949,132.66046 484.35949,133.20047 484.71949,133.74047 C 484.89949,134.10046 485.25949,134.64047 486.15949,134.64047 C 487.41949,134.64047 487.95949,133.74047 487.95949,133.02047 C 487.95949,132.12047 487.05949,131.76047 485.79949,131.40047 L 482.91949,130.68047 C 482.01949,130.32047 479.31949,129.60046 479.31949,126.72047 C 479.31949,125.28046 480.03949,124.02047 481.11949,123.30047 C 482.37949,122.40047 484.17949,122.04047 486.15949,122.04047 C 489.39949,122.04047 492.63949,122.94047 492.81949,127.08047 L 487.77949,127.08047 C 487.77949,126.54047 487.77949,126.00047 487.59949,125.64047 C 487.23949,125.10047 486.87949,124.74047 485.97949,124.74047 C 485.07949,124.74047 484.35949,125.10047 484.35949,126.00047 C 484.35949,126.90047 485.07949,127.26047 485.79949,127.44047 L 489.75949,128.52047 C 491.19949,128.88047 493.17949,129.78046 493.17949,132.48047 C 493.17949,137.52047 487.41949,137.52047 486.15949,137.52047 C 483.27949,137.52047 478.95949,136.98047 478.95949,132.30047 L 484.35949,132.30047 z ",
                  id: "path43",
                },
              }),
              _vm._v(" "),
              _c("path", {
                staticStyle: {
                  fill: "#ff6600",
                  "fill-rule": "nonzero",
                  stroke: "none",
                  "stroke-width": "0.28",
                  "stroke-linecap": "butt",
                  "stroke-linejoin": "bevel",
                },
                attrs: {
                  d: "M 419.01949,117.54047 C 419.01949,136.98047 434.85949,152.64047 454.29949,152.64047 C 458.79949,152.64047 463.11949,151.74047 467.43949,150.12047 L 464.73949,143.82047 C 461.49949,145.08047 457.89949,145.80047 454.29949,145.80047 C 438.63949,145.80047 425.85949,133.20047 425.85949,117.54047 C 425.85949,102.06046 438.63949,89.280465 454.29949,89.280465 C 469.77949,89.280465 482.55949,102.06046 482.55949,117.54047 L 482.55949,117.90047 L 489.39949,117.90047 L 489.39949,117.54047 C 489.39949,98.100465 473.55949,82.440465 454.29949,82.440465 C 434.85949,82.440465 419.01949,98.100465 419.01949,117.54047 z ",
                  id: "path45",
                },
              }),
            ]
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }